import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'immigrationTitle'
})
export class ImmigrationTitlePipe implements PipeTransform {

  transform(value: any, ...args: any[]): string {
    switch (value) {
      case 'VisaPreApproval':
        return 'Visa pre-approval';
      case 'BusinessVisa':
        return 'Business visa';
      case 'IqamaIssuance':
        return 'Iqama Issuance';
      case 'IqamaRenewal':
        return 'Iqama Renewal';
      case 'PassportInfoUpdate':
        return 'Passport Information Update';
      case 'GOSIadditional':
        return 'GOSI Addition';
      case 'GOSIremoval':
        return 'GOSI Removal';
      case 'VisaCancellation':
        return 'Iqama Cancellation';
      case 'ExitIqamatransfer':
        return 'Exit Iqama transfer';
      case 'Exitpermission':
        return 'Exit - Re-entry permit';
      case 'EmploymentVisa':
        return 'Employment Visa';
      case 'IqamaTransfer':
        return 'Iqama Transfer';
      case 'ARE-BusinessVisitVisa':
        return 'Business Visit Visa';
      case 'ARE-Tawteen':
        return 'Tawteen Approval';
      case 'ARE-BusinessVisitVisaRenewal':
        return 'Business Visit Visa Renewal';
      case 'ARE-BusinessVisitVisaCancellation':
        return 'Business Visit Visa Cancellation';
      case 'ARE-MissionVisa':
        return 'Mission Visa';
      case 'ARE-MissionVisaRenewal':
        return 'Mission Visa Renewal';
      case 'ARE-RelativeWorkPermit':
        return 'Labour card only (Work permit issuance)';
      case 'ARE-TemporaryPTWorkPermit':
        return 'Temporary / Part-time Work Permit';
      case 'ARE-UaeGccNationalWorkPermit':
        return 'UAE & GCC National Work Permit and Pension registration';
      case 'ARE-GccUaeNationalWorkPermitRenewal':
        return 'UAE & GCC National Work Permit Renewal';
      case 'ARE-DepVisaGccMarriedToExpat':
        return 'Dependent visa  - GCC nationals';
      case 'ARE-EmploymentVisaIssuance':
        return 'Employment Visa ';
      case 'ARE-EmploymentVisaRenewal':
        return 'Employment Visa Renewal';
      case 'ARE-DependentsVisaIssuance':
        return 'Dependents Visa - Expats';
      case 'ARE-DependentsVisaRenewal':
        return 'Dependents Visa Renewal';
      case 'ARE-PensionAddition':
        return 'Pension Addition';
      case 'ARE-PensionRemoval':
        return 'UAE/GCC National Labour card and Pension cancellation';
      case 'ARE-LabourCardCancellation':
        return 'Labour Card Cancellation';
      case 'ARE-VisaCancellationInside':
        return 'Employment visa cancellation';
      case 'ARE-VisaCancellationOutside':
        return 'Visa cancellation - Outside';
      case 'ARE-CicpaCard':
        return 'CICPA Card (Abu Dhabi only)';
      case 'ARE-ChangeOfProfession':
        return 'Change of Profession';
      case 'ARE-TransferResidency':
        return 'Transfer of residency to new passport';
      case 'ARE-ChangeOfNationality':
        return 'Change of Nationality';
      case 'OMN-WorkPermitPreAprroval':
        return 'Work permit pre-approval';
      case 'OMN-EmploymentVisa':
        return 'Employment visa';
      case 'OMN-ResidencyPermitTransfer':
        return 'Residency Permit (RP) transfer';
      case 'OMN-MOLContractIssuance':
        return 'MOL contract issuance';
      case 'OMN-ResidencyPermitIssuance':
        return 'Residency Permit (RP) issuance';
      case 'OMN-ResidencyPermitRenewal':
        return 'Residency Permit (RP) renewal';
      case 'OMN-ResidencyPermitCancellation':
        return 'Residency Permit (RP) cancellation';
      case 'OMN-ExitResidencyPermitTransfer':
        return 'Exit - Residency Permit (RP) transfer';
      case 'OMN-MOLContractCancellation':
        return 'MOL contract cancellation';
      case 'OMN-ShortTermVisa':
        return 'Short term visa';
      case 'OMN-ShortTermVisaExtension':
        return 'Short term visa extension';
      case 'OMN-DependentsVisa':
        return 'Dependent Visa Issuance';
      case 'OMN-TransferOfResidencyPermitToNewPassport':
        return 'Transfer of Residency Permit to new passport ';
      case 'OMN-LetterRequest':
        return 'Letter request';
      case 'OMN-DocumentAttestation':
        return 'Document attestation';
      case 'OMN-Other':
        return 'Other';
      case 'QAT-BusinessVisa':
        return 'Business Visa';
      case 'BHR-EmploymentVisa':
        return 'Employment visa';
      case 'BHR-VisaTransfer':
        return 'Employment visa transfer';
      case 'BHR-GOSIRegistration':
        return 'Pension registration';
      case 'BHR-ResidencyPermitAndCPRIssuance':
        return 'Residency permit (RP) and CPR issuance';
      case 'BHR-ResidencyPermitRenewal':
        return 'Residency permit (RP) renewal';
      case 'BHR-GOSITermination':
        return 'Pension cancellation';
      case 'BHR-ShortTermVisa':
        return 'Short term visa';
      case 'BHR-ShortTermVisaExtension':
        return 'Short term visa extension';
      case 'BHR-DependentsResidencyIssuance':
        return 'Dependents residency issuance';
      case 'BHR-ResidencyPermitCancellation':
        return 'Residency Permit (RP) cancellation';
      case 'BHR-ExitEmploymentVisaTransfer':
        return 'Exit - employment visa transfer';
      case 'BHR-KSABusinessVisaSupport':
        return 'KSA Business visa support';
      case 'BHR-TransferOfResidencyPermitToNewPassport':
        return 'Transfer of Residency Permit to new passport';
      case 'BHR-ChangeOfProfession':
        return 'Change of profession';
      case 'BHR-CPRSupport':
        return 'CPR Support';
      case 'BHR-LetterRequest':
        return 'Letter request';
      case 'BHR-Other':
        return 'Other';
      case 'OMN-ChangeOfProfession':
        return 'Change of profession';
      case 'QAT-VisaPreAprroval':
        return 'Employment visa pre-approval';
      case 'QAT-EmploymentVisa':
        return 'Employment visa ';
      case 'QAT-ResidencyPermitTransfer':
        return 'Residency Permit (RP) transfer';
      case 'QAT-ResidencyPermitIssuance':
        return 'Residency Permit Issuance';
      case 'QAT-WorkPermitIssuance':
        return 'Work Permit issuance ';
      case 'QAT-WorkPermitRenewal':
        return 'Work Permit renewal';
      case 'QAT-ResidencyPermitRenewal':
        return 'Residency Permit Renewal';
      case 'QAT-ResidencyPermitCancellation':
        return 'Residency Permit cancellation';
      case 'QAT-ExitResidencyPermitTransfer':
        return 'Exit - Residency Permit (RP) transfer ';
      case 'QAT-WorkPermitCancellation':
        return 'Work Permit cancellation ';
      case 'QAT-BusinessVisaExtension':
        return 'Business Visa Extension ';
      case 'QAT-ExitPermission':
        return 'Exit permission';
      case 'QAT-ChangeOfProfession':
        return 'Change of profession ';
      case 'QAT-TransferOfResidencyPermitToNewPassport':
        return 'Residency Permit Update - New Passport';
      case 'QAT-GovernmentGatePass':
        return 'Government gate pass';
      case 'QAT-LetterRequest':
        return 'Document request';
      case 'QAT-DocumentAttestation':
        return 'Document attestation';
      case 'QAT-Other':
        return 'Other';
      case 'KWT-VisaPreApproval':
        return 'Visa pre-approval';
      case 'KWT-EmploymentVisa':
        return 'Employment visa ';
      case 'KWT-ResidencyTransfer':
        return 'Residency Permit (RP) transfer';
      case 'KWT-ResidencePermitIssuance':
        return 'Residency Permit (RP) Issuance';
      case 'KWT-WorkPermitIssuance':
        return 'PIFSS & PAM registration (Work permit issuance)';
      case 'KWT-CommercialVisitVisa':
        return 'Commercial Visit visa ';
      case 'KWT-ResidencyRenewal':
        return 'Residency permit (RP) renewal';
      case 'KWT-WorkPermitRenewal':
        return 'Work permit renewal';
      case 'KWT-WorkPermitCancellation':
        return 'PIFSS & PAM cancellation(Work permit cancellation) ';
      case 'KWT-ResidencyPermitCancellation':
        return 'Residency Permit (RP) cancellation ';
      case 'KWT-ExitResidencyPermitTransfer':
        return 'Exit - Residency Permit (RP) transfer';
      case 'KWT-TransferOfResidencyToNewPassport':
        return 'Transfer of Residency to new passport ';
      case 'KWT-KSABusinessVIsaSupport':
        return 'KSA Business visa support ';
      case 'KWT-CivilIDSupport':
        return 'Civil ID support';
      case 'KWT-ChangeOfProfession':
        return 'Change of profession ';
      case 'KWT-DataModification':
        return 'Data Modification';
      case 'KWT-DependentsResidencyVisaSupport':
        return 'Dependents residency visa support ';
      case 'KWT-LetterRequest':
        return 'Letter request';
      case 'KWT-DocumentAttestation':
        return 'Document attestation';
      case 'KWT-Other':
        return 'Other';
      case 'ARE-GoldenVisa':
        return 'Golden Visa';
      case 'ARE-GoldenVisaRenewal':
        return 'Golden Visa Renewal';
      case 'ARE-RelativeWorkPermitRenewal':
        return 'Labour card only (Work Permit) Renewal';
      case 'KWT-CommercialVisitVisaExtension':
        return 'Commercial Visit Visa Extension';

      default:
        return 'Visa request';
    }
  }

}
